import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import Breadcrumb from '../../components/ui/Breadcrumb';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';
import DashboardStats from './components/DashboardStats';
import AssetDataGrid from './components/AssetDataGrid';
import FilterSidebar from './components/FilterSidebar';
import AssetDetailDrawer from './components/AssetDetailDrawer';
import FloorPlanView from './components/FloorPlanView';

const AssetManagementDashboard = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeTab, setActiveTab] = useState('inventory');
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [showDetailDrawer, setShowDetailDrawer] = useState(false);
  const [showFilters, setShowFilters] = useState(true);
  const [filters, setFilters] = useState({
    status: '',
    type: '',
    department: '',
    owner: ''
  });

  // Mock asset data
  const [assets, setAssets] = useState([
    {
      id: 1,
      assetId: 'AT-2025-0001',
      type: 'laptop',
      owner: 'Arjun Sharma',
      department: 'IT',
      purchaseDate: '2023-03-15',
      warrantyExpiration: '2026-03-15',
      status: 'active',
      location: 'room-103'
    },
    {
      id: 2,
      assetId: 'AT-2025-0002',
      type: 'desktop',
      owner: 'Priya Patel',
      department: 'HR',
      purchaseDate: '2022-08-22',
      warrantyExpiration: '2025-08-22',
      status: 'active',
      location: 'room-104'
    },
    {
      id: 3,
      assetId: 'AT-2025-0003',
      type: 'server',
      owner: 'Rahul Verma',
      department: 'IT',
      purchaseDate: '2021-12-10',
      warrantyExpiration: '2024-12-10',
      status: 'repair',
      location: 'room-102'
    },
    {
      id: 4,
      assetId: 'AT-2025-0004',
      type: 'printer',
      owner: 'Anjali Singh',
      department: 'Finance',
      purchaseDate: '2023-06-05',
      warrantyExpiration: '2026-06-05',
      status: 'active',
      location: 'room-103'
    },
    {
      id: 5,
      assetId: 'AT-2025-0005',
      type: 'laptop',
      owner: 'Vikram Nair',
      department: 'Marketing',
      purchaseDate: '2024-01-18',
      warrantyExpiration: '2027-01-18',
      status: 'spare',
      location: 'room-106'
    },
    {
      id: 6,
      assetId: 'AT-2025-0006',
      type: 'monitor',
      owner: 'Neha Gupta',
      department: 'Sales',
      purchaseDate: '2022-11-30',
      warrantyExpiration: '2025-11-30',
      status: 'active',
      location: 'room-103'
    },
    {
      id: 7,
      assetId: 'AT-2025-0007',
      type: 'tablet',
      owner: 'Suresh Reddy',
      department: 'Operations',
      purchaseDate: '2023-09-12',
      warrantyExpiration: '2026-09-12',
      status: 'active',
      location: 'room-107'
    },
    {
      id: 8,
      assetId: 'AT-2025-0008',
      type: 'phone',
      owner: 'Kavita Joshi',
      department: 'Legal',
      purchaseDate: '2024-02-28',
      warrantyExpiration: '2027-02-28',
      status: 'retired',
      location: 'room-106'
    },
    {
      id: 9,
      assetId: 'AT-2025-0009',
      type: 'laptop',
      owner: 'Arjun Sharma',
      department: 'IT',
      purchaseDate: '2023-05-20',
      warrantyExpiration: '2026-05-20',
      status: 'active',
      location: 'room-103'
    },
    {
      id: 10,
      assetId: 'AT-2025-0010',
      type: 'server',
      owner: 'Rahul Verma',
      department: 'IT',
      purchaseDate: '2022-04-15',
      warrantyExpiration: '2025-04-15',
      status: 'active',
      location: 'room-102'
    },
    {
      id: 11,
      assetId: 'AT-2025-0011',
      type: 'desktop',
      owner: 'Priya Patel',
      department: 'HR',
      purchaseDate: '2023-07-08',
      warrantyExpiration: '2026-07-08',
      status: 'spare',
      location: 'room-104'
    },
    {
      id: 12,
      assetId: 'AT-2025-0012',
      type: 'printer',
      owner: 'Anjali Singh',
      department: 'Finance',
      purchaseDate: '2022-10-25',
      warrantyExpiration: '2025-10-25',
      status: 'repair',
      location: 'room-103'
    },
    {
      id: 13,
      assetId: 'AT-2025-0013',
      type: 'monitor',
      owner: 'David Wilson',
      department: 'Marketing',
      purchaseDate: '2024-03-12',
      warrantyExpiration: '2027-03-12',
      status: 'active',
      location: 'room-103'
    },
    {
      id: 14,
      assetId: 'AT-2025-0014',
      type: 'laptop',
      owner: 'Lisa Anderson',
      department: 'Sales',
      purchaseDate: '2023-11-18',
      warrantyExpiration: '2026-11-18',
      status: 'active',
      location: 'room-103'
    },
    {
      id: 15,
      assetId: 'AT-2025-0015',
      type: 'tablet',
      owner: 'Robert Taylor',
      department: 'Operations',
      purchaseDate: '2024-01-05',
      warrantyExpiration: '2027-01-05',
      status: 'retired',
      location: 'room-106'
    }
  ]);

  const filteredAssets = assets?.filter(asset => {
    return ((!filters?.status || asset?.status === filters?.status) &&
    (!filters?.type || asset?.type === filters?.type) &&
    (!filters?.department || asset?.department === filters?.department) && (!filters?.owner || asset?.owner === filters?.owner));
  });

  const handleAssetClick = (asset) => {
    setSelectedAsset(asset);
    setShowDetailDrawer(true);
  };

  const handleAssetUpdate = (updatedAsset) => {
    setAssets(prev => prev?.map(asset => 
      asset?.id === updatedAsset?.id ? updatedAsset : asset
    ));
    setSelectedAsset(updatedAsset);
  };

  const handleLocationUpdate = (assetId, newLocation) => {
    setAssets(prev => prev?.map(asset => 
      asset?.id === assetId ? { ...asset, location: newLocation } : asset
    ));
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const handleClearFilters = () => {
    setFilters({
      status: '',
      type: '',
      department: '',
      owner: ''
    });
  };

  const handleBulkAction = (action) => {
    console.log(`Bulk action: ${action} on assets:`, selectedAssets);
    if (action === 'export') {
      // Mock CSV export
      const selectedAssetData = assets?.filter(asset => selectedAssets?.includes(asset?.id));
      console.log('Exporting CSV for assets:', selectedAssetData);
    }
  };

  const handleSavePreset = () => {
    console.log('Saving filter preset:', filters);
  };

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Asset Management Dashboard - AssetTracker Pro</title>
        <meta name="description" content="Comprehensive IT asset management dashboard for tracking, monitoring, and managing organizational assets with real-time visibility and audit capabilities." />
      </Helmet>

      <Header />
      
      <div className="flex">
        <Sidebar 
          isCollapsed={sidebarCollapsed} 
          onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)} 
        />
        
        <main className={`flex-1 transition-layout ${
          sidebarCollapsed ? 'ml-16' : 'ml-72'
        } mt-16`}>
          <div className="p-8">
            <div className="max-w-full">
              {/* Page Header */}
              <div className="mb-8">
                <Breadcrumb />
                <div className="flex items-center justify-between">
                  <div>
                    <h1 className="text-3xl font-bold text-foreground">Asset Management Dashboard</h1>
                    <p className="text-muted-foreground mt-2">
                      Comprehensive visibility and control over your IT asset lifecycle
                    </p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Button
                      variant="outline"
                      iconName="Download"
                      iconPosition="left"
                      onClick={() => handleBulkAction('export')}
                    >
                      Export Data
                    </Button>
                    <Button
                      variant="outline"
                      iconName="RefreshCw"
                      iconPosition="left"
                    >
                      Sync ERP
                    </Button>
                    <Button
                      variant="default"
                      iconName="Plus"
                      iconPosition="left"
                    >
                      Add Asset
                    </Button>
                  </div>
                </div>
              </div>

              {/* Dashboard Stats */}
              <DashboardStats assets={filteredAssets} />

              {/* Tab Navigation */}
              <div className="mb-6">
                <div className="border-b border-border">
                  <nav className="flex space-x-8">
                    <button
                      onClick={() => setActiveTab('inventory')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm transition-smooth ${
                        activeTab === 'inventory' ?'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                      }`}
                    >
                      <div className="flex items-center space-x-2">
                        <Icon name="Table" size={16} />
                        <span>Inventory Grid</span>
                      </div>
                    </button>
                    <button
                      onClick={() => setActiveTab('floorplan')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm transition-smooth ${
                        activeTab === 'floorplan' ?'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                      }`}
                    >
                      <div className="flex items-center space-x-2">
                        <Icon name="Map" size={16} />
                        <span>Floor Plan</span>
                      </div>
                    </button>
                  </nav>
                </div>
              </div>

              {/* Main Content Area */}
              <div className="flex gap-6">
                {/* Filter Sidebar */}
                {activeTab === 'inventory' && showFilters && (
                  <FilterSidebar
                    filters={filters}
                    onFilterChange={handleFilterChange}
                    onClearFilters={handleClearFilters}
                    onSavePreset={handleSavePreset}
                  />
                )}

                {/* Content Area */}
                <div className={`flex-1 ${activeTab === 'inventory' && showFilters ? '' : 'max-w-full'}`}>
                  {/* Filter Toggle for Inventory */}
                  {activeTab === 'inventory' && (
                    <div className="mb-4">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setShowFilters(!showFilters)}
                        iconName={showFilters ? "PanelLeftClose" : "PanelLeftOpen"}
                        iconPosition="left"
                      >
                        {showFilters ? 'Hide' : 'Show'} Filters
                      </Button>
                    </div>
                  )}

                  {/* Tab Content */}
                  {activeTab === 'inventory' ? (
                    <AssetDataGrid
                      assets={filteredAssets}
                      selectedAssets={selectedAssets}
                      onSelectionChange={setSelectedAssets}
                      onAssetClick={handleAssetClick}
                      onBulkAction={handleBulkAction}
                    />
                  ) : (
                    <FloorPlanView
                      assets={filteredAssets}
                      onAssetClick={handleAssetClick}
                      onLocationUpdate={handleLocationUpdate}
                    />
                  )}
                </div>

                {/* Asset Detail Drawer */}
                <AssetDetailDrawer
                  asset={selectedAsset}
                  isOpen={showDetailDrawer}
                  onClose={() => setShowDetailDrawer(false)}
                  onUpdate={handleAssetUpdate}
                />
              </div>

              {/* Footer with Audit Instructions */}
              <div className="mt-12 p-6 bg-muted/30 rounded-lg border border-border">
                <div className="flex items-start space-x-4">
                  <Icon name="Info" size={20} className="text-primary mt-0.5" />
                  <div>
                    <h3 className="text-sm font-semibold text-foreground mb-2">
                      Quarterly Audit Instructions
                    </h3>
                    <p className="text-sm text-muted-foreground mb-3">
                      The next quarterly audit is scheduled for September 2025. Ensure all asset locations are verified and status updates are current.
                    </p>
                    <div className="flex items-center space-x-4">
                      <Button
                        variant="outline"
                        size="sm"
                        iconName="ClipboardCheck"
                        iconPosition="left"
                      >
                        Start Audit Process
                      </Button>
                      <Button
                        variant="ghost"
                        size="sm"
                        iconName="FileText"
                        iconPosition="left"
                      >
                        View Audit Guidelines
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AssetManagementDashboard;